//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { subscribeToQuery } from 'datocms-listen'
import createQuery from '~/gql/landingPage.gql'
import { mergeDeep } from '~/helpers/objects'
import { setPageTheme } from '~/helpers/themes'

export default {
  async asyncData ({ $contentAPI, error, $sentry, route, query, store }) {
    const slug = route.meta[0].slug || route.params.pathMatch

    const gqlQuery = createQuery(slug)
    const preview = process.client && query.preview

    const result = await $contentAPI.fetch({ query: gqlQuery, preview })
    if (!result || !result.landingPage || result.errors) {
      const errorsToLog = result.errors || 'Error fetching page'
      $sentry.captureException(errorsToLog)
      return error({ statusCode: 404, message: `Unable to load ${slug}` })
    }

    const activeVariantSku = route.meta[0].sku || (result.landingPage.products.length ? result.landingPage.products[0].sku : null)
    const activeVariant = result.landingPage.products.find(product => product.sku === activeVariantSku) || {}

    const pageTheme = activeVariant.pageThemeOverride || result.landingPage.pageTheme || null
    await setPageTheme(store, pageTheme)

    return { ...result.landingPage, query: gqlQuery, activeVariantSku }
  },
  head () {
    // Meta is an array serverside and an object clientside, normalise it
    const meta = Array.isArray(this.$route.meta) ? this.$route.meta : [this.$route.meta]

    return mergeDeep(
      this.$head(this.meta),
      meta[0].index ? {} : { meta: [{ hid: 'robots', name: 'robots', content: 'noindex' }] }
    )
  },
  computed: {
    activeVariant () {
      return this.products.find(product => product.sku === this.activeVariantSku) || {}
    }
  },
  watch: {
    activeVariantSku () {
      this.setPageTheme()
    }
  },
  async mounted () {
    if (this.$route.query.preview) {
      this.unsubscribe = await subscribeToQuery({
        token: this.$config.datoApiToken,
        query: this.query,
        preview: true,
        onChannelError: this.onChannelError,
        onUpdate: this.onUpdate
      })
    }
    
    // Scroll to a row on this page
    if (this.$route.query.scroll) {
      // Get a list of row ids from the URL, map to DOM ids and filter to those that exist and are visible
      const scrollTargets = this.$route.query.scroll.split(',').map(
        id => `#row-${id}`
      ).filter(
        id => (document.querySelector(id) || {}).offsetParent
      )

      // If there are any valid scrollTargets then scroll to the first
      if (scrollTargets) this.$scrollTo(scrollTargets[0], { duration: 600, force: false, offset: -200 })
    }
  },
  methods: {
    unsubscribe () {},
    onChannelError (error) {
      console.error(error)
    },
    onUpdate (update) {
      const { rows, pageTheme } = update.response.data.landingPage
      this.rows = rows
      this.pageTheme = pageTheme
      this.setPageTheme()
    },
    setActiveVariant (variant) {
      this.activeVariantSku = variant.sku
    },
    setPageTheme () {
      setPageTheme(this.$store, this.activeVariant.pageThemeOverride || this.pageTheme)
    }
  }
}
